"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizedApiClient = void 0;
const base_client_1 = require("@deliverr/base-client");
class CustomizedApiClient extends base_client_1.ApiClient {
    constructor(config) {
        super(config);
        this.axiosInstance = this.axios;
    }
    withAccessToken(token) {
        return super.withAccessToken(token);
    }
    addBeforeEach(beforeEach) {
        return super.addBeforeEach(beforeEach);
    }
    getBatch(path, query) {
        return super.getBatch(path, query);
    }
    get(path, query, headers) {
        return super.get(path, query, headers);
    }
    getWithHeadersInResponse(path, query, headers) {
        return super.getWithHeadersInResponse(path, query, headers);
    }
    post(path, body, query) {
        return super.post(path, body, query);
    }
    postWithHeadersInResponse(path, body, query) {
        return super.postWithHeadersInResponse(path, body, query);
    }
    postWithStatusInResponse(path, body, query, headers) {
        return super.postWithStatusInResponse(path, body, query, headers);
    }
    postWithHeaders(path, body, query, headers) {
        return super.postWithHeaders(path, body, query, headers);
    }
    delete(path, query, body) {
        return super.delete(path, query, body);
    }
    put(path, body, query) {
        return super.put(path, body, query);
    }
    patch(path, body, query) {
        return super.patch(path, body, query);
    }
    getCached(url, params, expiry, verbose) {
        return super.getCached(url, params, expiry, verbose);
    }
    request(requestConfig) {
        return super.request(requestConfig);
    }
    maybeGetDeliverrError(err) {
        return super.maybeGetDeliverrError(err);
    }
    maybeGetNetworkError(err) {
        return super.maybeGetNetworkError(err);
    }
    getUnknownError(err) {
        return super.getUnknownError(err);
    }
}
exports.CustomizedApiClient = CustomizedApiClient;
//# sourceMappingURL=CustomizedApiClient.js.map